import { Link } from 'react-router-dom';
import './KitchenFittersPage.css';

const COLLECT = [
  {
    title: 'Exhausts & Catalytic Converters',
    image: '/images/vehicle-garages/garage-exhausts-cats.png',
  },
  {
    title: 'Engine & Gearbox Parts',
    image: '/images/vehicle-garages/garage-engine-parts.png',
  },
  {
    title: 'Wheels & Rims',
    image: '/images/vehicle-garages/garage-wheels-rims.png',
  },
  {
    title: 'Brake Discs & Components',
    image: '/images/vehicle-garages/garage-brake-discs.png',
  },
  {
    title: 'Metal Brackets & Offcuts',
    image: '/images/vehicle-garages/garage-brackets-offcuts.png',
  },
  {
    title: 'Workshop Metal & Frames',
    image: '/images/vehicle-garages/garage-workshop-metal.png',
  },
];

const STEPS = [
  {
    n: '1',
    title: 'Post your scrap',
    body: 'Add photos, your postcode and what workshop metal needs clearing.',
  },
  {
    n: '2',
    title: 'We find collectors',
    body: 'Nearby licensed collectors review your listing and offer a collection window.',
  },
  {
    n: '3',
    title: 'Collector confirms',
    body: 'Agree access, parking and timing around your busy workshop day.',
  },
  {
    n: '4',
    title: 'Scrap is collected',
    body: 'Exhausts, parts and metal leave the bay through licensed handling routes.',
  },
  {
    n: '5',
    title: 'You get more done',
    body: 'Your team stays on repairs while workshop leftovers are cleared away.',
  },
];

const REASONS = [
  {
    title: 'Licensed & verified collectors',
    body: 'Matched collectors are verified scrap carriers — not unlicensed tip runs.',
  },
  {
    title: 'Compliant & safe',
    body: 'Keep bays tidy with accountable collections for workshop metal.',
  },
  {
    title: 'Cost effective',
    body: 'Post for free and avoid losing time hauling exhausts and parts yourself.',
  },
  {
    title: 'Better for the environment',
    body: 'Automotive metals are recovered for reuse instead of mixed waste.',
  },
  {
    title: 'Built for busy workshops',
    body: 'Share access notes and photos so collectors arrive ready for garage scrap.',
  },
];

const TRUST = [
  { label: 'Save time', detail: 'Clear bay leftovers fast' },
  { label: 'Save money', detail: 'Free to post online' },
  { label: 'Recycle more', detail: 'Metal recovered properly' },
  { label: 'Stay compliant', detail: 'Licensed collectors only' },
];

export default function VehicleGaragesPage() {
  return (
    <div className="kf-page">
      <section className="kf-hero" aria-labelledby="vg-hero-heading">
        <div className="kf-hero-inner">
          <div className="kf-hero-copy">
            <p className="kf-kicker">SnapScrap for trade</p>
            <h1 id="vg-hero-heading">
              Scrap collection for <span>vehicle garages & workshops</span>
            </h1>
            <p className="kf-lead">
              Clear exhausts, parts and workshop metal quickly and responsibly — so your next
              repair day stays tidy and productive.
            </p>

            <div className="kf-hero-actions">
              <Link className="kf-btn" to="/post-scrap">
                Post scrap free →
              </Link>
              <Link className="kf-btn kf-btn-ghost" to="/how-it-works">
                See how it works
              </Link>
            </div>

            <ul className="kf-trust">
              {TRUST.map((item) => (
                <li key={item.label}>
                  <strong>{item.label}</strong>
                  <span>{item.detail}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="kf-hero-media">
            <img
              src="/images/businesses/biz-vehicle-garages.png"
              alt="Vehicle garage and workshop scrap ready for collection"
            />
            <p className="kf-hero-note">
              Built for garage crews — exhausts, engines, wheels, brakes and offcuts
            </p>
          </div>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="vg-collect-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="vg-collect-heading">What scrap we collect</h2>
            <p>Typical metal leftovers from vehicle repairs, servicing and workshop clear-outs</p>
          </header>

          <ul className="kf-collect-grid">
            {COLLECT.map((item) => (
              <li key={item.title}>
                <div className="kf-collect-image">
                  <img src={item.image} alt="" loading="lazy" />
                </div>
                <h3>{item.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-section kf-section-tint" aria-labelledby="vg-steps-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="vg-steps-heading">How SnapScrap works</h2>
            <p>Five simple steps from posting leftovers to a clearer workshop</p>
          </header>

          <ol className="kf-steps">
            {STEPS.map((step) => (
              <li key={step.n}>
                <span className="kf-step-n" aria-hidden="true">
                  {step.n}
                </span>
                <h3>{step.title}</h3>
                <p>{step.body}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="kf-section" aria-labelledby="vg-why-heading">
        <div className="kf-inner">
          <header className="kf-header">
            <h2 id="vg-why-heading">Why garages & workshops choose SnapScrap</h2>
            <p>Clear space, keep bays moving, and handle metal the responsible way</p>
          </header>

          <ul className="kf-why-grid">
            {REASONS.map((item) => (
              <li key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="kf-cta" aria-label="Post scrap call to action">
        <div className="kf-cta-inner">
          <div className="kf-cta-copy">
            <h2>Post your workshop scrap for free today</h2>
            <p>
              List leftovers from your next garage clear-out or parts job and get matched with a
              licensed collector.
            </p>
          </div>
          <Link className="kf-btn kf-btn-light" to="/post-scrap">
            Post scrap free →
          </Link>
        </div>
      </section>
    </div>
  );
}
